import {Geek, GeekItem} from '.';
import {Skill} from './skill.enum';

export interface ActivitySubtype {
  id: number;
  name: string;
  rewardGxp: number;
}

export interface TranslatedActivitySubtype extends ActivitySubtype {
  translatedName: string;
}

export interface ActivityGroup {
  activityTypes: TranslatedActivityType[];
  skill: Skill;
}

export interface ActivityType {
  id: number;
  name: string;
  gxp: number;
  subtypes?: ActivitySubtype[];
  canHaveSignature?: boolean;
}

export interface TranslatedActivityType extends ActivityType {
  translatedName: string;
}

export interface ActivityHistory {
  id: string;
  createdAt: Date;
  geek: GeekItem;
  type: ActivityType;
  subtype?: ActivitySubtype;
  reason: string;
  status: ActivityHistoryStatusType;
  requestedBy: GeekItem;
  adminReason: string;
  grantedBy: GeekItem;
  quantity: number;
}

export enum ActivityHistoryStatusType {
  Unknown = '',
  Accepted = 'accepted',
  Rejected = 'rejected',
  AddedByAdmin = 'added-by-admin',
}

export interface WaitingActivityRequests {
  id: string;
  createdAt: string;
  geek: GeekItem;
  activity: ActivityType;
  subtypes?: ActivitySubtype;
  reason: string;
  requestedBy: GeekItem;
  redirectionRecipient: GeekItem;
}

export interface ResponseToActivityRequestsResponse {
  id: string;
  reason: string;
}

export interface RedirectActivityRequestsResponse {
  id: string;
  reason: string;
  recipientId?: string;
}
